const NETWORK_ERROR_PATTERNS = [
  'failed to fetch',
  'load failed',
  'networkerror',
  'network request failed',
  'fetch failed',
  'network error',
];

const TIMEOUT_ERROR_PATTERNS = [
  'aborterror',
  'timeout',
  'timed out',
];

export const normalizeUserFacingErrorMessage = (input, fallback = 'Произошла ошибка') => {
  const rawMessage = typeof input === 'string' ? input : input?.message;
  const message = String(rawMessage || '').trim();

  if (!message) return fallback;

  const lower = message.toLowerCase();

  if (NETWORK_ERROR_PATTERNS.some((pattern) => lower.includes(pattern))) {
    return 'Нет соединения с сервером. Проверьте интернет.';
  }

  if (TIMEOUT_ERROR_PATTERNS.some((pattern) => lower.includes(pattern))) {
    return 'Сервер не отвечает. Попробуйте позже.';
  }

  return message;
};

